import { useEffect } from 'react';
import { useSocket } from '../contexts/SocketContext';

interface AgentStatus {
  agentId: string;
  employeeId: string;
  email: string;
  firstName: string;
  lastName: string;
  status: string;
  timestamp: string;
  source: 'ZENDESK' | 'KUSTOMER';
}

interface UseAgentStatusSyncOptions {
  organizationId: string;
  onStatusChange?: (agentStatus: AgentStatus) => void;
}

export function useAgentStatusSync({ organizationId, onStatusChange }: UseAgentStatusSyncOptions) {
  const { socket, isConnected } = useSocket();

  // Subscribe to agent status updates
  useEffect(() => {
    if (!socket || !isConnected || !organizationId) {
      return;
    }

    // Subscribe to agent status room
    socket.emit('subscribe:agent-status', { organizationId });

    // Listen for agent status changes
    const handleStatusChange = (data: AgentStatus) => {
      console.log('Agent status changed:', data);
      if (onStatusChange) {
        onStatusChange(data);
      }
    };

    socket.on('agent:status-changed', handleStatusChange);

    // Cleanup
    return () => {
      socket.off('agent:status-changed', handleStatusChange);
    };
  }, [socket, isConnected, organizationId, onStatusChange]);

  return {
    isConnected,
  };
}
